export const getMourvedreFranceData = () => ({
  name: "Mourvèdre",
  country: "France",
  description: "Le Mourvèdre est principalement cultivé en Provence, où il produit des vins rouges puissants et structurés.",
  regions: [
    { name: "Provence", area: "2,500 ha", percentage: "50%", description: "Cépage principal" },
    { name: "Bandol", area: "1,500 ha", percentage: "30%", description: "Vins de garde" },
    { name: "Languedoc-Roussillon", area: "800 ha", percentage: "16%", description: "Assemblage" },
    { name: "Côtes du Rhône", area: "200 ha", percentage: "4%", description: "Usage limité" }
  ],
  mapAreas: [
    { region: "Provence", x: 65, y: 70, color: "#4B164C", size: 6 },
    { region: "Bandol", x: 65, y: 75, color: "#6d2c7a", size: 4 },
    { region: "Languedoc-Roussillon", x: 50, y: 65, color: "#8a4a8a", size: 3 },
    { region: "Côtes du Rhône", x: 58, y: 55, color: "#a768a6", size: 1 }
  ],
  subregions: {
    provence: {
      name: "Provence",
      description: "Le Mourvèdre de Provence produit des vins rouges puissants et structurés, avec un excellent potentiel de vieillissement.",
      characteristics: {
        aromas: "Fruits noirs mûrs, notes de garrigue, épices, cuir",
        body: "Corps plein et puissant",
        tannins: "Tannins fermes et structurés",
        aging: "Excellent potentiel (10-20 ans)"
      },
      terroir: {
        climate: "Climat méditerranéen chaud et sec",
        soil: "Sols calcaires et galets roulés",
        viticulture: "Rendements limités, vendanges tardives"
      },
      differentiators: [
        "Puissance et concentration uniques",
        "Notes de garrigue caractéristiques",
        "Structure tannique marquée",
        "Style robuste et authentique"
      ],
      foodPairing: "Viandes rouges, gibier, plats méditerranéens, fromages affinés"
    }
  }
}); 